import React from 'react';

import FirstTitle from "../../../shared/items/static/firstTitle"
import Icon from "../../../shared/items/static/icon"
import locales from "./../../../content.json"

import styles from "./reviewsResultBlock.module.scss"

const reviews = [
  {
    name: locales[window.userLang].review_name_1,
    title: locales[window.userLang].review_title_1,
    rate: 100,
    review: locales[window.userLang].review_content_1,
  },
  {
    name: locales[window.userLang].review_name_2,
    title: locales[window.userLang].review_title_2,
    rate: 90,
    review: locales[window.userLang].review_content_2,
  },
  {
    name: locales[window.userLang].review_name_3,
    title: locales[window.userLang].review_title_3,
    rate: 100,
    review: locales[window.userLang].review_content_3,
  },
]

const ReviewsResultBlock = () => {
  return (
    <div className={styles.reviewsResult}>
      <FirstTitle>{locales[window.userLang].reviews}</FirstTitle>

      <div className={styles.reviewsList}>
        {
          reviews.map((item, index) => {
            return (
              <div className={styles.reviewItem} key={index}>
                <div className={styles.titleBlock}>
                  <span className={styles.title}>{item.title}</span>
                  <span className={styles.name}>{item.name}</span>
                </div>
                <div className={styles.rate}>
                  <div className={styles.active} style={{ width: `${item.rate}%`, backgroundImage: `url(./img/stars.png)` }}></div>
                  <div className={styles.disabled} style={{ backgroundImage: `url(./img/stars-d.png)` }}></div>
                </div>
                <div className={styles.container_review}>
                  <p className={styles.review}>{item.review}</p>
                </div>
              </div>
            )
          })
        }
      </div>

      <div className={styles.container_stat}>
        <FirstTitle>{locales[window.userLang].join}</FirstTitle>

        <div className={styles.statistic}>
          <div className={styles.item}  >
            <div className={styles.iconWorkout}>
              <Icon name="join_icon_3" />
            </div>
            <p className={styles.about}><b>17 000 </b>{locales[window.userLang].daily_workouts}</p>
          </div>
          <div className={styles.item}>
            <div className={styles.iconUsers}>
              <Icon name="users" />
            </div>
            <p className={styles.about}><b>70 000 000</b> {locales[window.userLang].happy_users}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReviewsResultBlock;